import Parse from "parse";

import type { Media } from "./Media";
import type { _Role } from "./_Role";

type OD3_Tenant = Parse.Object;

export interface Schedule_StepAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description?: string;
  fields?: any[];
  media: Parse.Relation<Schedule_Step, Media>;
  roles: Parse.Relation<Schedule_Step, _Role>;
  tenant?: OD3_Tenant;
  title?: string;
}

export class Schedule_Step extends Parse.Object<Schedule_StepAttributes> {
  static className: string = "OD3_Maintenance_Schedule_Step";

  constructor(data?: Partial<Schedule_StepAttributes>) {
    super("OD3_Maintenance_Schedule_Step", data as Schedule_StepAttributes);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get fields(): any[] | undefined {
    return super.get("fields");
  }
  set fields(value: any[] | undefined) {
    super.set("fields", value);
  }
  get media(): Parse.Relation<Schedule_Step, Media> {
    return super.relation("media");
  }
  get roles(): Parse.Relation<Schedule_Step, _Role> {
    return super.relation("roles");
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Schedule_Step", Schedule_Step);
